export var STORAGE = {
  pdfDocument: 'pdfDocument',
  uploadedFile: 'uploadedFile',
  authToken: 'authToken',
  isOpenTour: 'isOpenTour'
};
export var EDITOR_TOOLS = {
  text: 'text',
  freeform: 'freeform'
};
export var EDITOR_STEPS = {
  edit: 'edit',
  review: 'review'
};